'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import CodeSplitEnvWrapper from 'pricing-pages-unified-ui/components/CodeSplitEnvWrapper';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { productBasedOfferIdsWithMandatorySkuSelector } from '../../selectors/ProductBasedOffersSelectors';
import { suiteProductConfigurationsSelector } from '../../selectors/ProductConfigsSelectors';
import { quantityPackProductConfigurationsFromProductInventorySelector } from '../../selectors/ProductInventorySelectors';
import { suitePurchaseMotionsMapSelector } from '../../selectors/PurchaseMotionSelectors';
import { useQueryParamTerm } from '../../utils/stateUtils';
import LoadingMerchCardAuthedCTAs from '../loading/LoadingMerchCardAuthedCTAs';
import LoadingMerchCardPublicCTAs from '../loading/LoadingMerchCardPublicCTAs';
import { useSuiteTileAuthedCTAsProps } from './useSuiteTileAuthedCTAsProps';

const SuiteTileCTAsContainer = props => {
  const {
    sourceId,
    productLevel,
    hubsSignupProductOverride,
    ctaStyles = {}
  } = props;
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const suiteProductConfigurations = useSelector(state => suiteProductConfigurationsSelector(state, {
    productLevel
  }));
  const ownedQuantityPackProductConfigurations = useSelector(state => {
    return quantityPackProductConfigurationsFromProductInventorySelector(state, {
      baseProductConfigurations: suiteProductConfigurations
    });
  });
  const checkoutProductConfigurations = [...suiteProductConfigurations, ...ownedQuantityPackProductConfigurations];
  const productBasedOfferIds = useSelector(state => productBasedOfferIdsWithMandatorySkuSelector(state, {
    skuIds: checkoutProductConfigurations.map(({
      skuId
    }) => skuId)
  }));
  const suitePurchaseMotions = useSelector(state => suitePurchaseMotionsMapSelector(state)[productLevel]);
  return /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
    authedComponentLoader: () => import(
    /* webpackChunkName: "authed-chunk" */
    `pricing-pages-unified-ui/components/suite-page/SuiteTileAuthedCTAs`),
    publicComponentLoader: () => import(
    /* webpackChunkName: "public-chunk" */
    `pricing-pages-unified-ui/components/public-only/PublicPurchaseMotionButton`),
    authedComponentProps: Object.assign({}, props),
    publicComponentProps: {
      use: 'primary',
      productConfigurations: checkoutProductConfigurations,
      purchaseMotions: suitePurchaseMotions,
      productBasedOfferIds,
      sourceId: sourceId || 'pricing-hero',
      dtbSource: `pricing-page|growthsuite|${productLevel.toLowerCase()}`,
      numPurchaseMotions: 1,
      maxNumPurchaseMotions: 1,
      queryParamTerm,
      hubsSignupProductOverride,
      style: ctaStyles
    },
    publicComponentLoadingState: LoadingMerchCardPublicCTAs,
    authedComponentLoadingState: LoadingMerchCardAuthedCTAs,
    useCommonAuthedProps: useSuiteTileAuthedCTAsProps
  });
};

SuiteTileCTAsContainer.propTypes = {
  productLevel: PropTypes.string.isRequired,
  sourceId: PropTypes.string,
  hubsSignupProductOverride: PropTypes.string,
  ctaStyles: PropTypes.object
};
export default SuiteTileCTAsContainer;